export const getPathname = () => window.location.pathname;
